import { reactive, toRef } from 'vue';

const store = new Map();

export function useState(key, initialValue = null) {
    if (!store.has(key)) {
        store.set(key, reactive({ value: initialValue }));
    }
    const state = store.get(key);
    return toRef(state, 'value');
}

export function setState(key, value) {
    const state = store.get(key);
    if (state) {
        state.value = value;
    } else {
        const newState = reactive({ value });
        store.set(key, newState);
    }
}

export function getState(key, initialValue = null) {
    if (store.has(key)) {
        const state = store.get(key);
        return toRef(state, 'value');
    }

    //Don't create a ref with the key unless we provide a default value
    if (initialValue !== null) {
        setState(key, initialValue);
        const state = store.get(key);
        return toRef(state, 'value');
    }

    return undefined;
}

export function deleteState(key) {
    return store.delete(key);
}

export function clearState() {
    store.clear();
}
